import { Component, OnInit } from '@angular/core';
import { TransferHttpService } from '../../../../services/transfer-http/transfer-http.service';
import { PermissionsService } from '../../../../services/permissions/permissions.service';
import { AimsCommonTableHeader, AimsCommonTablePermissions } from '@aims/common-components';

@Component({
  selector: 'view-inspection-reports',
  templateUrl: './view-inspection-reports.component.html',
  styleUrls: ['./view-inspection-reports.component.css']
})
export class ViewInpectionReportsComponent implements OnInit {

  // AimsCommonTable setup
  tableHeader: AimsCommonTableHeader[] = [
    { key: 'details', label: 'Details', type: 'button', prefix: '/projectSupport/inspectionReport/', linkId: 'inspectionReportId', filter: false },
    { key: 'reportName', label: 'Report Name', type: 'string', width: 200 },
    { key: 'inspectionDate', label: 'Inspection Date', type: 'date' },
    { key: 'siteCode', label: 'Site', type: 'string', width: 100 },
    { key: 'fullName', label: 'Primary Inspector', type: 'string', width: 100 },
  ];
  tablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false,
  };


  constructor(public transferHttp: TransferHttpService,
    public permissions: PermissionsService) {
  }

  //***************************
  // Variables
  //***************************

  user = this.transferHttp.getCache("user");
  pageHeader: string = "View Inspection Reports";

  //Main Grid
  inspectionReports = this.transferHttp.getSingle('QualityControl/ViewInspectionReports');

  //***************************
  // Functions
  //***************************


  //***************************
  // Init
  //***************************

  ngOnInit(): void {
  }

}
